import { createAction, props } from '@ngrx/store';
export const setReportOrientation = createAction('[Custom PDF Report Builder] Set Report Orientation', props());
